import clsx from 'clsx';
import Grid from '@mui/material/Grid2';
import { AboutCard } from '../ProductDetail/AboutCard';
import { LocationForm } from './LocationForm';
import {
  ACTIVE_LOCATIONS,
  ActiveCountriesEnum,
  DEFAULT_LOCATION,
} from '../Location/config';
import { useTypedDispatch } from '../../redux/hooks';
import { locationActionCreators } from '../../redux/slices/location/actionCreators';
import { AnalyticEventsEnum, trackEvent } from '../../Analytics';

import sg from '../../styles/global.module.scss';

export const CountryCard = ({
  country,
  setSelectedCountry,
}: {
  country: ActiveCountriesEnum;
  setSelectedCountry: React.Dispatch<
    React.SetStateAction<ActiveCountriesEnum | undefined>
  >;
}) => {
  return (
    <Grid size={6}>
      <AboutCard
        title={country}
        onClick={async () => {
          setSelectedCountry(country);
          await trackEvent(AnalyticEventsEnum.LOCATION__SELECTED, {
            location: country,
          });
        }}
        icon={
          <p style={{ fontSize: '22px' }}>
            {ACTIVE_LOCATIONS[country].flagEmoji}
          </p>
        }
      />
    </Grid>
  );
};

export const Welcome = ({
  submitModal,
  setSelectedCountry,
}: {
  submitModal: () => void;
  setSelectedCountry: React.Dispatch<
    React.SetStateAction<ActiveCountriesEnum | undefined>
  >;
}) => {
  const dispatch = useTypedDispatch();
  return (
    <>
      <div style={{ padding: '10px' }} className={clsx(sg.Stack_Vertical)}>
        <p
          style={{
            fontSize: '26px',
            fontFamily: 'Montserrat',
            textAlign: 'center',
            marginBottom: '20px',
          }}
        >
          Select event location
        </p>

        <Grid container spacing={1} alignItems="stretch">
          <CountryCard
            country={ActiveCountriesEnum.Spain}
            setSelectedCountry={setSelectedCountry}
          />

          <Grid size={6}>
            <AboutCard
              onClick={async () => {
                trackEvent(AnalyticEventsEnum.LOCATION__SELECTED, {
                  location: DEFAULT_LOCATION.description,
                });
                await dispatch(
                  locationActionCreators.selectLocation(DEFAULT_LOCATION)
                );
                submitModal();
              }}
              icon={<p style={{ fontSize: '22px' }}>🌴</p>}
              title={DEFAULT_LOCATION.inputMain}
            />
          </Grid>
        </Grid>

        <LocationForm submitModal={submitModal} placement="welcome" />
      </div>
    </>
  );
};
